// Component: LatestNewsGridCard
// Author: Vijay Radhakrishnan

import React from 'react';
import { Text, RichText, Image, withPlaceholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import LatestNewsGridCardComponent from '@component/LatestNewsGridCard';

const LatestNewsGridCard = (props) => {
  return (
    <>
      <LatestNewsGridCardComponent
        image={<img src={props.fields?.Image?.value?.src} alt={props.fields?.Image?.value?.alt} />}
        date={props.fields?.Date?.value}
        title={<Text field={props.fields?.Title} />}
        text={<RichText field={props.fields?.Description} />}
        linkText={<Text field={props.fields?.LinkText} />}
        linkUrl={props.fields?.Link.value.href}
        linkTarget={props.fields?.Link.value.target}
        locale={props.sitecoreContext?.language}
      />
    </>
  );
};

const compWithPlaceholder = withPlaceholder('Latest-News-Grid-Card')(LatestNewsGridCard);
const compWithSitecoreCtx = withSitecoreContext()(compWithPlaceholder);

export default compWithSitecoreCtx;
